import { render, staticRenderFns } from "./document-Index.vue?vue&type=template&id=260617d1&scoped=true"
import script from "./document-Index.vue?vue&type=script&lang=js"
export * from "./document-Index.vue?vue&type=script&lang=js"
import style0 from "./document-Index.vue?vue&type=style&index=0&id=260617d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260617d1",
  null
  
)

export default component.exports